<template>
  <ClientsForm :client="client" :onSubmit="submit"></ClientsForm>
</template>

<script>
import ClientsForm from './Clients-Form.vue';
import { ClientStoreModel } from '../../store/modules/clients';
import { busEvent } from '../../main';

export default {
  name: 'create-clients',
  components: {
    ClientsForm,
  },
  data: () => ({
    client: { ...ClientStoreModel },
  }),
  methods: {
    submit() {
      this.$store.dispatch('clients/createClient', this.client)
        .then((client) => {
          busEvent.$emit('succesPopupCreated', 'Clientul a fost adaugat');
          this.$router.push({ path: `/clients/${client.id}/documents` });
        });
    },
  },
};
</script>
